<template>
  <div class="mt-2 d-flex flex-row pointer" @click.stop="object[field] = !object[field]">
    <i class="fas fa-check-circle  mt-1 ms-1" :class="object[field] ? 'text-success' : 'text-secondary'"></i>
    <div class="ms-2">{{label}}</div>
  </div>
</template>

<script>
export default {
    name: 'CheckboxControl',
    props: ['field', 'label', 'object']
}
</script>

<style>

</style>
